/**
 * The Quelby wordmark: renders quelby-lockup.svg, which bakes in the "quelby"
 * text with its Space Grotesk font embedded — so it renders pixel-identical
 * everywhere (including to crawlers/reviewers that don't load web fonts),
 * instead of depending on the page's own font loading like the old
 * icon+styled-text version did.
 */
export function Wordmark({ size = "1.25rem" }: { size?: string }) {
  return <img src="/brand/quelby-lockup.svg" alt="quelby" style={{ height: size, width: "auto" }} />;
}
